import styled, { css } from 'styled-components';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { unit, pxToRem } from '../../foundation/spacing/utils.js';

var primaryStyles = css(["background-color:", ";color:", ";[data-icon='falcon']{color:", ";}"], themeGet('colors.secondary.500'), themeGet('colors.primary.0'), themeGet('colors.primary.0'));
var secondaryStyles = css(["background-color:", ";color:", ";[data-icon='falcon']{color:", ";}"], themeGet('colors.gray.50'), themeGet('colors.text.200'), themeGet('colors.text.200'));
var successStyles = css(["background-color:", ";color:", ";[data-icon='falcon']{color:", ";}"], themeGet('colors.green.500'), themeGet('colors.gray.0'), themeGet('colors.gray.0'));
var dangerStyles = css(["background-color:", ";color:", ";[data-icon='falcon']{color:", ";}"], themeGet('colors.red.500'), themeGet('colors.gray.0'), themeGet('colors.gray.0'));
var warningStyles = css(["background-color:", ";color:", ";[data-icon='falcon']{color:", ";}"], themeGet('colors.yellow.500'), themeGet('colors.text.300'), themeGet('colors.text.300'));
var infoStyles = css(["background-color:", ";color:", ";[data-icon='falcon']{color:", ";}"], themeGet('colors.blue.500'), themeGet('colors.gray.0'), themeGet('colors.gray.0'));
var lightStyles = css(["background-color:", ";color:", ";[data-icon='falcon']{color:", ";}"], themeGet('colors.gray.0'), themeGet('colors.text.300'), themeGet('colors.text.300'));
var darkStyles = css(["background-color:", ";color:", ";[data-icon='falcon']{color:", ";}"], themeGet('colors.gray.1000'), themeGet('colors.gray.0'), themeGet('colors.gray.0'));
var mediumDotSizeStyles = css(["height:", ";width:", ";border-radius:100%;left:calc(100% - ", ");transform:translate(-20%,20%);"], unit('md'), unit('md'), unit('md'));
var mediumSizeStyles = css(["font-size:", ";height:", ";min-width:", ";border-radius:", ";padding:", ";left:calc(100% - ", " / 2);[data-icon='falcon']{height:", ";width:", ";}"], themeGet('fontSize.medium'), unit('2xl'), unit('2xl'), unit('2xl'), pxToRem(6), unit('2xl'), unit('lg'), pxToRem(9));
var smallDotSizeStyles = css(["height:", ";width:", ";border-radius:100%;left:calc(100% - ", ");transform:translate(-150%,50%);"], unit('sm'), unit('sm'), unit('sm'));
var smallSizeStyles = css(["font-size:", ";height:", ";min-width:", ";border-radius:", ";padding:", ";left:calc(100% - ", " / 1.5);[data-icon='falcon']{height:", ";width:", ";}"], themeGet('fontSize.small'), pxToRem(20), pxToRem(20), pxToRem(20), unit('sm'), pxToRem(20), unit('lg'), pxToRem(9));
var largeDotSizeStyles = css(["height:", ";min-width:", ";border-radius:100%;left:calc(100% - ", ");transform:translate(0%,0%);"], unit('lg'), unit('lg'), unit('lg'));
var largeSizeStyles = css(["font-size:", ";height:", ";min-width:", ";border-radius:", ";padding:", ";left:calc(100% - ", " / 2.5);[data-icon='falcon']{height:", ";width:", ";}"], themeGet('fontSize.large'), unit('3xl'), unit('3xl'), unit('3xl'), unit('md'), unit('3xl'), unit('xl'), unit('xl'));
var appearanceStyles = function appearanceStyles(appearance) {
  switch (appearance) {
    case 'secondary':
      return secondaryStyles;
    case 'success':
      return successStyles;
    case 'danger':
      return dangerStyles;
    case 'info':
      return infoStyles;
    case 'dark':
      return darkStyles;
    case 'warning':
      return warningStyles;
    case 'light':
      return lightStyles;
    case 'primary':
    default:
      return primaryStyles;
  }
};
var sizeStyles = function sizeStyles(size, dot) {
  switch (size) {
    case 'small':
      return dot ? smallDotSizeStyles : smallSizeStyles;
    case 'large':
      return dot ? largeDotSizeStyles : largeSizeStyles;
    case 'medium':
    default:
      return dot ? mediumDotSizeStyles : mediumSizeStyles;
  }
};
var pillPositionStyles = css(["position:absolute;box-sizing:border-box;top:0;transform:translate(-20%,-20%);"]);
var BadgeBox = styled.div.withConfig({
  displayName: "BadgeBox",
  componentId: "sc-f45sr3-0"
})(["position:relative;width:max-content;height:max-content;display:flex;flex-direction:row;justify-content:center;align-items:center;"]);
var Pill = styled.div.withConfig({
  displayName: "Pill",
  componentId: "sc-f45sr3-1"
})(["display:flex;flex-direction:row;justify-content:center;align-items:center;font-weight:", ";z-index:1;", ";", ";", ""], themeGet('fontWeight.medium'), function (_ref) {
  var $adjustPosition = _ref.$adjustPosition;
  return $adjustPosition && pillPositionStyles;
}, function (_ref2) {
  var $appearance = _ref2.$appearance;
  return appearanceStyles($appearance);
}, function (_ref3) {
  var $size = _ref3.$size,
    $dot = _ref3.$dot;
  return sizeStyles($size, $dot);
});

export { BadgeBox, Pill };
